import { ViewController } from '@estee/elc-service';
import { action, observable } from 'mobx';

export class DeliveryInfoModalViewController extends ViewController {
    @observable public isOpen: boolean;
    isLoading = false;

    @action
    public openModal = () => {
        this.isOpen = true;
    };

    @action
    public closeModal = () => {
        this.isOpen = false;
    };
}
